import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Radio, Map, FileText, Wind, Compass, DollarSign, AlertTriangle, X, ClipboardList, ExternalLink } from 'lucide-react';
const tabs = [{
  id: 'frequencies',
  label: 'Frekvence',
  icon: Radio
}, {
  id: 'circuits',
  label: 'Okruhy a Dráha',
  icon: Compass
}, {
  id: 'fees',
  label: 'Poplatky',
  icon: DollarSign
}, {
  id: 'arrival-form',
  label: 'Příletový formulář',
  icon: ClipboardList,
  externalUrl: 'https://forms.gle/jREeEspwa3jHGTkF9'
}, {
  id: 'info',
  label: 'Další info',
  icon: FileText
}];
export function PilotInfo() {
  const [activeTab, setActiveTab] = useState('frequencies');
  const [lightboxImage, setLightboxImage] = useState<string | null>(null);
  useEffect(() => {
    if (lightboxImage) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [lightboxImage]);
  const handleTabClick = (tab: (typeof tabs)[number]) => {
    if ('externalUrl' in tab && tab.externalUrl) {
      window.open(tab.externalUrl, '_blank', 'noopener,noreferrer');
    } else {
      setActiveTab(tab.id);
    }
  };
  return <section id="pilot-info" className="py-24 bg-[#0a1628]" data-id="element-185">
      <div className="max-w-5xl mx-auto px-6" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-187">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-188">
            Informace pro piloty
          </h2>
          <p className="text-white/60 max-w-2xl mx-auto mb-6" data-id="element-189">
            Základní údaje z Letištního řádu. Vždy si před letem ověřte aktuální
            AIP a NOTAMy.
          </p>
          <a href="https://aim.rlp.cz/vfrmanual/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium text-[#38bdf8] border-2 border-[#38bdf8] rounded-none hover:bg-[#38bdf8] hover:text-[#0a1628] transition-all duration-300" data-id="element-190">
            <ExternalLink size={16} data-id="element-191" />
            VFR příručka
          </a>
        </motion.div>

        {/* Tabs Navigation */}
        <div className="flex flex-wrap justify-center gap-2 mb-8" data-id="element-192">
          {tabs.map(tab => {
          const isExternal = 'externalUrl' in tab && tab.externalUrl;
          return <button key={tab.id} onClick={() => handleTabClick(tab)} className={`flex items-center gap-2 px-6 py-3 rounded-full text-sm font-medium transition-all duration-300 ${isExternal ? 'bg-[#f87171] text-white hover:bg-[#ef4444]' : activeTab === tab.id ? 'bg-[#38bdf8] text-[#0a1628]' : 'bg-[#0f1d35] text-white/60 hover:bg-[#1e3a5f] hover:text-white'}`} data-id="element-193">
                <tab.icon size={16} data-id="element-194" />
                {tab.label}
                {isExternal && <ExternalLink size={12} className="ml-0.5 opacity-60" data-id="element-195" />}
              </button>;
        })}
        </div>

        {/* Tab Content */}
        <div className="bg-[#0f1d35] border border-white/5 rounded-2xl p-8 md:p-12 min-h-[400px]" data-id="element-196">
          <AnimatePresence mode="wait" data-id="element-197">
            {activeTab === 'frequencies' && <motion.div key="frequencies" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} data-id="element-198">
                <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-199">
                  <Radio className="text-[#38bdf8]" data-id="element-200" /> Radiové frekvence
                </h3>

                {/* Desktop Table */}
                <div className="hidden md:block overflow-hidden rounded-xl border border-white/10 mb-8" data-id="element-201">
                  <table className="w-full text-left" data-id="element-202">
                    <thead className="bg-[#0a1628]" data-id="element-203">
                      <tr data-id="element-204">
                        <th className="p-4 text-white/50 font-medium text-sm uppercase tracking-wider" data-id="element-205">
                          Stanice
                        </th>
                        <th className="p-4 text-white/50 font-medium text-sm uppercase tracking-wider" data-id="element-206">
                          Volací znak
                        </th>
                        <th className="p-4 text-white/50 font-medium text-sm uppercase tracking-wider" data-id="element-207">
                          Frekvence
                        </th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-white/5" data-id="element-208">
                      <tr className="bg-[#0f1d35]" data-id="element-209">
                        <td className="p-4 text-white font-medium" data-id="element-210">RADIO</td>
                        <td className="p-4 text-white/70" data-id="element-211">HOŘOVICE RADIO</td>
                        <td className="p-4 text-[#38bdf8] font-mono font-bold text-lg" data-id="element-212">
                          135.580 MHz
                        </td>
                      </tr>
                      <tr className="bg-[#0f1d35]" data-id="element-213">
                        <td className="p-4 text-white font-medium" data-id="element-214">Nouzová</td>
                        <td className="p-4 text-white/70" data-id="element-215">Obecná</td>
                        <td className="p-4 text-red-400 font-mono font-bold text-lg" data-id="element-216">
                          121.500 MHz
                        </td>
                      </tr>
                      <tr className="bg-[#0f1d35]" data-id="element-217">
                        <td className="p-4 text-white font-medium" data-id="element-218">ATIS</td>
                        <td className="p-4 text-white/70" data-id="element-219">Praha</td>
                        <td className="p-4 text-white/40 font-mono" data-id="element-220">
                          122.160 MHz
                        </td>
                      </tr>
                      <tr className="bg-[#0f1d35]" data-id="element-221">
                        <td className="p-4 text-white font-medium" data-id="element-222">VOLMET</td>
                        <td className="p-4 text-white/70" data-id="element-223">-</td>
                        <td className="p-4 text-white/40 font-mono" data-id="element-224">
                          125.525 MHz
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* Mobile Cards */}
                <div className="md:hidden space-y-3 mb-8" data-id="element-225">
                  <div className="bg-[#0a1628] rounded-xl border border-white/5 p-4" data-id="element-226">
                    <div className="flex justify-between items-start mb-1" data-id="element-227">
                      <span className="text-white font-medium" data-id="element-228">RADIO</span>
                      <span className="text-[#38bdf8] font-mono font-bold" data-id="element-229">
                        135.580 MHz
                      </span>
                    </div>
                    <span className="text-white/50 text-sm" data-id="element-230">
                      HOŘOVICE RADIO
                    </span>
                  </div>
                  <div className="bg-[#0a1628] rounded-xl border border-white/5 p-4" data-id="element-231">
                    <div className="flex justify-between items-start mb-1" data-id="element-232">
                      <span className="text-white font-medium" data-id="element-233">Nouzová</span>
                      <span className="text-red-400 font-mono font-bold" data-id="element-234">
                        121.500 MHz
                      </span>
                    </div>
                    <span className="text-white/50 text-sm" data-id="element-235">Obecná</span>
                  </div>
                  <div className="bg-[#0a1628] rounded-xl border border-white/5 p-4" data-id="element-236">
                    <div className="flex justify-between items-start mb-1" data-id="element-237">
                      <span className="text-white font-medium" data-id="element-238">ATIS</span>
                      <span className="text-white/50 font-mono" data-id="element-239">
                        122.160 MHz
                      </span>
                    </div>
                    <span className="text-white/50 text-sm" data-id="element-240">Praha</span>
                  </div>
                  <div className="bg-[#0a1628] rounded-xl border border-white/5 p-4" data-id="element-241">
                    <div className="flex justify-between items-start mb-1" data-id="element-242">
                      <span className="text-white font-medium" data-id="element-243">VOLMET</span>
                      <span className="text-white/50 font-mono" data-id="element-244">
                        125.525 MHz
                      </span>
                    </div>
                    <span className="text-white/50 text-sm" data-id="element-245">-</span>
                  </div>
                </div>

                <div className="p-4 bg-[#38bdf8]/10 border border-[#38bdf8]/20 rounded-lg" data-id="element-246">
                  <p className="text-[#38bdf8] text-sm" data-id="element-247">
                    <strong data-id="element-248">Poznámka:</strong> Provozní doba RADIO není pevně
                    stanovena (O/R). Přílety bez rádia pouze po předchozí
                    domluvě.
                  </p>
                </div>
              </motion.div>}

            {activeTab === 'circuits' && <motion.div key="circuits" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} data-id="element-249">
                <div className="grid md:grid-cols-2 gap-8" data-id="element-250">
                  <div data-id="element-251">
                    <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-252">
                      <Wind className="text-[#38bdf8]" data-id="element-253" /> Dráhový systém
                    </h3>
                    <div className="bg-[#0a1628] p-6 rounded-xl border border-white/5 mb-6" data-id="element-254">
                      <div className="flex justify-between items-center mb-4" data-id="element-255">
                        <span className="text-xl font-bold text-white" data-id="element-256">
                          RWY 06 / 24
                        </span>
                        <span className="px-3 py-1 bg-[#38bdf8]/20 text-[#38bdf8] rounded text-sm font-bold" data-id="element-257">
                          ASFALT
                        </span>
                      </div>
                      <div className="space-y-2 text-sm text-white/70" data-id="element-258">
                        <p data-id="element-259">
                          Rozměry: <strong data-id="element-260">1170 x 30 m</strong>
                        </p>
                        <p data-id="element-261">
                          Únosnost: <strong data-id="element-262">PCN 25/R/B/U</strong>
                        </p>
                        <p data-id="element-263">
                          Sklon: <strong data-id="element-264">0.18%</strong> (stoupá k RWY 24)
                        </p>
                        <p className="text-yellow-400/80" data-id="element-265">
                          Pozor: Posunuté prahy na obou drahách!
                        </p>
                      </div>
                    </div>

                    {/* Runway Diagram Thumbnail */}
                    <div className="relative overflow-hidden rounded-xl border border-white/10 cursor-pointer group" onClick={() => setLightboxImage('https://cdn.magicpatterns.com/uploads/u3egShru5eatQbgsvmYZ6f/lkhv_adc.webp')} data-id="element-266">
                      <img src="https://cdn.magicpatterns.com/uploads/u3egShru5eatQbgsvmYZ6f/lkhv_adc.webp" alt="ADC mapa letiště LKHV" className="w-full h-auto object-contain bg-white/90 p-2 transition-transform duration-500 group-hover:scale-105" data-id="element-267" />
                      <div className="absolute inset-0 bg-[#0a1628]/40 transition-opacity duration-300 group-hover:opacity-0" data-id="element-268" />
                    </div>
                  </div>

                  <div data-id="element-269">
                    <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-270">
                      <Compass className="text-[#38bdf8]" data-id="element-271" /> Okruhy
                    </h3>
                    <ul className="space-y-4" data-id="element-272">
                      <li className="flex items-start gap-3 text-white/80" data-id="element-273">
                        <span className="w-2 h-2 bg-[#38bdf8] rounded-full mt-2" data-id="element-274" />
                        <span data-id="element-275">
                          <strong data-id="element-276">Pouze SEVERNÍ okruhy</strong> pro všechna
                          letadla.
                          <br data-id="element-277" />
                          <span className="text-sm text-white/50" data-id="element-278">
                            RWY 06 točte DOLEVA, RWY 24 točte DOPRAVA.
                          </span>
                        </span>
                      </li>
                      <li className="flex items-start gap-3 text-white/80" data-id="element-279">
                        <span className="w-2 h-2 bg-[#38bdf8] rounded-full mt-2" data-id="element-280" />
                        <span data-id="element-281">
                          Výška okruhu:{' '}
                          <strong className="text-white" data-id="element-282">2 300 ft AMSL</strong>{' '}
                          (QNH)
                          <br data-id="element-283" />
                          <span className="text-sm text-white/50" data-id="element-284">
                            Minimální výška 1. a 4. zatáčky: 1575 ft AMSL.
                          </span>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="mt-8 p-6 bg-red-500/10 border border-red-500/20 rounded-xl" data-id="element-285">
                  <h4 className="text-red-400 font-bold flex items-center gap-2 mb-2" data-id="element-286">
                    <AlertTriangle size={20} data-id="element-287" /> Omezení hluku a přeletů
                  </h4>
                  <ul className="list-disc list-inside text-white/70 space-y-1 text-sm" data-id="element-288">
                    <li data-id="element-289">
                      Zákaz opakovaných nízkých průletů a postupů nezdařeného
                      přistání (hluková zátěž obce Tlustice).
                    </li>
                    <li data-id="element-290">
                      Po vzletu z RWY 24 se vyhněte doleva obci{' '}
                      <strong data-id="element-291">Záluží</strong>.
                    </li>
                    <li data-id="element-292">
                      Po vzletu z RWY 06 se vyhněte doleva obcím{' '}
                      <strong data-id="element-293">Kotopeky</strong> a <strong data-id="element-294">Praskolesy</strong>.
                    </li>
                    <li data-id="element-295">
                      Pozor na modelářskou činnost jižně od prahu dráhy 24.
                    </li>
                  </ul>
                </div>
              </motion.div>}

            {activeTab === 'fees' && <motion.div key="fees" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} data-id="element-296">
                <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-297">
                  <DollarSign className="text-[#38bdf8]" data-id="element-298" /> Poplatky
                </h3>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-299">
                  <div className="bg-[#0a1628] border border-white/5 rounded-xl overflow-hidden" data-id="element-300">
                    <div className="p-4 bg-white/5 border-b border-white/5 font-bold text-white" data-id="element-301">
                      Přistávací poplatky
                    </div>
                    <div className="p-4 space-y-4" data-id="element-302">
                      <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-303">
                        <span className="text-white/70" data-id="element-304">
                          Ultralehká letadla
                        </span>
                        <span className="text-[#38bdf8] font-bold" data-id="element-305">120 Kč</span>
                      </div>
                      <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-306">
                        <span className="text-white/70" data-id="element-307">
                          Letadla do 2000 kg MTOW
                        </span>
                        <span className="text-[#38bdf8] font-bold" data-id="element-308">150 Kč</span>
                      </div>
                      <div className="flex justify-between items-center" data-id="element-309">
                        <span className="text-white/70" data-id="element-310">Nad 2000 kg MTOW</span>
                        <span className="text-[#38bdf8] font-bold" data-id="element-311">
                          270 Kč{' '}
                          <span className="text-xs text-white/40 font-normal" data-id="element-312">
                            + 140 Kč/t
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="bg-[#0a1628] border border-white/5 rounded-xl overflow-hidden h-min" data-id="element-313">
                    <div className="p-4 bg-white/5 border-b border-white/5 font-bold text-white" data-id="element-314">
                      Ostatní
                    </div>
                    <div className="p-4 space-y-4" data-id="element-315">
                      <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-316">
                        <span className="text-white/70" data-id="element-317">
                          Parkování (za den)
                        </span>
                        <span className="text-[#38bdf8] font-bold" data-id="element-318">140 Kč</span>
                      </div>
                      <div className="flex justify-between items-center" data-id="element-319">
                        <span className="text-white/70" data-id="element-320">
                          Neoprávněné přistání
                        </span>
                        <span className="text-red-400 font-bold" data-id="element-321">
                          od 10 000 Kč
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <p className="mt-6 text-sm text-white/50 text-center" data-id="element-322">
                  Poplatky lze uhradit pomocí QR kódů umístěných v blízkosti
                  stanoviště RADIO.
                </p>
              </motion.div>}

            {activeTab === 'info' && <motion.div key="info" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} data-id="element-323">
                <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-324">
                  <FileText className="text-[#38bdf8]" data-id="element-325" /> Doplňující informace
                </h3>

                <div className="space-y-6" data-id="element-326">
                  <div className="bg-[#0a1628] p-6 rounded-xl border border-white/5" data-id="element-327">
                    <h4 className="text-white font-bold mb-2" data-id="element-328">ATZ Zóna</h4>
                    <p className="text-white/70 text-sm mb-2" data-id="element-329">
                      Horizontálně: Kruh o poloměru{' '}
                      <strong data-id="element-330">3 NM (5,5 km)</strong> od ARP.
                      <br data-id="element-331" />
                      Vertikálně: GND do <strong data-id="element-332">4 000 ft AMSL</strong> (1200
                      m).
                    </p>
                    <p className="text-white/50 text-xs" data-id="element-333">
                      Pozor na TMA II Praha (spodní hranice 3500 ft AMSL) v SV
                      části a prostor LKTSA-7 v JV části.
                    </p>
                  </div>

                  <div className="bg-[#0a1628] p-6 rounded-xl border border-white/5" data-id="element-334">
                    <h4 className="text-white font-bold mb-2" data-id="element-335">
                      Náhradní letiště
                    </h4>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm" data-id="element-336">
                      <li className="text-white/70" data-id="element-337">
                        <strong className="text-white" data-id="element-338">Příbram (LKPM)</strong>
                        <br data-id="element-339" />
                        118.755 MHz, 20 km
                      </li>
                      <li className="text-white/70" data-id="element-340">
                        <strong className="text-white" data-id="element-341">Beroun (LKBU)</strong>
                        <br data-id="element-342" />
                        134.305 MHz, 25 km
                      </li>
                      <li className="text-white/70" data-id="element-343">
                        <strong className="text-white" data-id="element-344">Kladno (LKKL)</strong>
                        <br data-id="element-345" />
                        123.480 MHz, 30 km
                      </li>
                      <li className="text-white/70" data-id="element-346">
                        <strong className="text-white" data-id="element-347">Rakovník (LKRA)</strong>
                        <br data-id="element-348" />
                        123.510 MHz, 30 km
                      </li>
                    </ul>
                  </div>

                  <div className="bg-[#0a1628] p-6 rounded-xl border border-white/5" data-id="element-349">
                    <h4 className="text-white font-bold mb-2" data-id="element-350">
                      Kontrolní bod výškoměrů
                    </h4>
                    <p className="text-white/70 text-sm" data-id="element-351">
                      Odbavovací plocha před hangárem aeroklubu:{' '}
                      <strong data-id="element-352">381 m (1 249 ft) AMSL</strong>
                    </p>
                  </div>
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>

      {/* Lightbox for runway diagram */}
      <AnimatePresence data-id="element-353">
        {lightboxImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 md:p-8" onClick={() => setLightboxImage(null)} data-id="element-354">
            <button className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors z-50 bg-black/20 p-2 rounded-full backdrop-blur-md" onClick={e => {
          e.stopPropagation();
          setLightboxImage(null);
        }} data-id="element-355">
              <X size={32} data-id="element-356" />
            </button>
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9,
          opacity: 0
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} className="relative max-w-5xl max-h-[90vh] w-full flex items-center justify-center" onClick={e => e.stopPropagation()} data-id="element-357">
              <img src={lightboxImage} alt="ADC mapa letiště LKHV" className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl bg-white p-2" data-id="element-358" />
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}